var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{staticClass:"input-field",attrs:{"label":"Time Range"}},[_c('TimeRangeEditor',{attrs:{"optional":true,"default-time-range":_vm.reportDefaultTimeRange,"default-time-range-name":_vm.reportDefaultTimeRange?.name || ''},model:{value:(_vm.inputs),callback:function ($$v) {_vm.inputs=$$v},expression:"inputs"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }